import { render, staticRenderFns } from "./visualcheck.vue?vue&type=template&id=4f70b0ce&"
import script from "./visualcheck.vue?vue&type=script&lang=js&"
export * from "./visualcheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports